module.exports = __webpack_public_path__ + "static/media/loading.54bcee95.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/loading.gif
// module id = 95
// module chunks = 0